import request from '@/utils/request'

export function getItem(data) {
  return request({
    url: '/CoachInfo/Get',
    method: 'post',
    data: { id: data },
  })
}

export function fetchList(data) {
  return request({
    url: '/CoachInfo/List',
    method: 'post',
    data,
  })
}

export function createItem(data) {
  // console.log('createItem', data)

  return request({
    url: '/CoachInfo/Create',
    method: 'post',
    data,
  })
}

export function updateItem(data) {
  // console.log('coachUpdate', data)

  return request({
    url: '/CoachInfo/update',
    method: 'post',
    data,
  })
}

export function deleteItem(data) {
  return request({
    url: '/CoachInfo/Delete',
    method: 'delete',
    data,
  })
}
